import React from "react";
import Button from "./Button";
import { ButtonTypes } from "../../utils/Constants";

const LastConfirmWarningModal: React.FC<{
  onCancel: () => void;
  onConfirm: () => void;
  onBackdrop: () => void;
  title: string;
  message: string;
  confirmButton: string;
  confirmDisabled?: boolean;
}> = ({
  onCancel,
  onConfirm,
  onBackdrop,
  title,
  message,
  confirmButton,
  confirmDisabled
}) => {

    return (
      <div
        className="backdrop"
        onClick={() => onBackdrop()}
      >
        <section
          className="bg-white shadow-md p-6 cursor-auto w-[90%] max-w-[492px] 480:w-[100%] rounded overflow-hidden"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => {
            if (e.key === "Enter") e.stopPropagation();
          }}
        >
          <h3 className="capitalize text-black27 text-xl font-semibold">
            {title}
          </h3>
          <p
            className="text-black41 mt-10 break-words whitespace-normal"
          >
            {message}
          </p>
          <div className="flex mt-10 justify-end gap-2">
            <Button type={ButtonTypes.CANCEL} onClick={() => onCancel()} className="!px-4 !py-2">
              Cancel
            </Button>

            <Button type={ButtonTypes.PRIMARY} onClick={() => onConfirm()} className="!px-4 !py-2 flex" disabled={confirmDisabled}>
              {confirmButton}
            </Button>
          </div>
        </section>
      </div>
    );
  };

export default LastConfirmWarningModal;
